import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function getAllArchivedUsers(callback) {
	firebaseRef.ref('/users/').on('value', async (snapshot) => {
		let userArr = [];

		let users = snapshot.val();
		if (users) {
			let userKeys = Object.keys(users);

			let projectCodes = [];
			await firebaseRef
				.ref('/kavtek_companies/')
				.once('value', (snapshot) => {
					let companyParent = snapshot.val();
					if (companyParent) {
						projectCodes = Object.keys(companyParent);
					}
				});
			for (let key of userKeys) {
				let projectRolesKeys = [];
				let projectRoles = users[key]?.projectRoles;
				if (projectRoles) {
					projectRolesKeys = Object.keys(projectRoles);
				}
				let intersectionArr = projectRolesKeys.filter((ele) =>
					projectCodes.includes(ele)
				);

				if (
					intersectionArr.length > 0 &&
					users[key]?.archived === true
				) {
					let rolesArr = [];
					if (projectRoles) {
						for (let projectId of projectRolesKeys) {
							await firebaseRef
								.ref('/kavtek_roles/' + projectId)
								.once('value', (snapshot) => {
									let roles = snapshot.val();
									if (roles) {
										let filteredRoles = Object.values(
											roles
										).filter(
											(role) =>
												role.roleId ===
												projectRoles[projectId]
										);
										if (filteredRoles.length > 0) {
											rolesArr.push({
												id: filteredRoles[0].roleId,
												name: filteredRoles[0].roleName,
												color: filteredRoles[0].color,
											});
										}
									}
								});
						}
					}

					userArr.push({ ...users[key], id: key, roles: rolesArr });
				}
			}
		}

		callback(userArr);
	});
}
